// import React, { useEffect, useRef } from 'react';
// import { gsap } from 'gsap';
// import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function HomePage() {
	return (
		<div className='homepage'>
			<div className='banner'>
				<img src='assets/logo-white.png' alt='' />
			</div>
			<hr />
			<div className='meal-deal'>
				<h2>Introducing</h2>
				<h1>Ultimate</h1>
				<h2>Meal Deal</h2>
				<p>Available for Delivery and Carry-out at select locations</p>
				<Link to='meal-deal'>see details</Link>
			</div>
			<hr />
			<div className='food-items'>
				<div className='image-container'>
					<img src='assets/bgi__sauce.png' alt='' />
				</div>

				<h1>Lets Eat</h1>
				<ul>
					<li>
						<Link to='/menu'>FAMOUS STUFFED PIZZA</Link>
					</li>
					<li>
						<Link to='/menu'>HAND-STRETCHED THIN CRUST</Link>
					</li>
					<li>
						<Link to='/menu'>CRIPSPY EXTRA THIN CRUST</Link>
					</li>
					<li>
						<Link to='/menu'>STARTERS</Link>
					</li>
					<li>
						<Link to='/menu'>SALADS</Link>
					</li>
					<li>
						<Link to='/menu'>SANDWICHES</Link>
					</li>
					<li>
						<Link to='/menu'>CLASIC ITALIAN</Link>
					</li>
					<li>
						<Link to='/menu'>DESSERT</Link>
					</li>
					<li>
						<Link to='/menu'>LUNCH PRONTO</Link>
					</li>
				</ul>
			</div>
		</div>
	);
}
